import { useState, useCallback, useMemo, useRef, useEffect } from 'react'
import { GridSelection, CompactSelection } from '@glideapps/glide-data-grid'
import { CellChange } from '../gridModel'

export const useMetadataGrid = () => {
  const [changes, setChanges] = useState<Map<string, CellChange>>(new Map())
  const [validationErrors, setValidationErrors] = useState<Map<string, string>>(new Map())
  const [gridSelection, setGridSelection] = useState<GridSelection>({
    columns: CompactSelection.empty(),
    rows: CompactSelection.empty()
  })

  const changesRef = useRef(changes)
  useEffect(() => {
    changesRef.current = changes
  }, [changes])

  const validationErrorsRef = useRef(validationErrors)
  useEffect(() => {
    validationErrorsRef.current = validationErrors
  }, [validationErrors])

  const resetState = useCallback(() => {
    setChanges(new Map())
    setValidationErrors(new Map())
  }, [])

  const batchUpdateChanges = useCallback((newChanges: Map<string, CellChange>) => {
    setChanges(() => newChanges)
  }, [])

  const batchUpdateErrors = useCallback((newErrors: Map<string, string>) => {
    setValidationErrors(newErrors)
  }, [])

  const hasValidationErrors = useMemo(() => validationErrors.size > 0, [validationErrors.size])
  const hasChanges = useMemo(() => changes.size > 0, [changes.size])

  return {
    changes,
    changesRef,
    validationErrorsRef,
    validationErrors,
    gridSelection,
    setGridSelection,
    hasValidationErrors,
    hasChanges,
    resetState,
    batchUpdateChanges,
    batchUpdateErrors
  }
}
